<template>
  <div class="login">
    <div class="backdrop">
      <img class="img-scale" src="../../assets/images/backdrop.png" alt="" />
    </div>
    <!-- 登录框 -->
    <div class="register">
      <el-card class="box-card">
        <div class="headline clearfix">广东海川工业物联网</div>
        <el-form
          ref="ApsPlan"
          :model="formData"
          :rules="rules"
          size="medium"
          label-width="60px"
        >
          <el-form-item label="用户" prop="name">
            <el-input
              v-model="formData.name"
              placeholder="请输入用户"
              clearable
              :style="{ width: '100%' }"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              v-model="formData.password"
              placeholder="请输入密码"
              clearable
              show-password
              :style="{ width: '100%' }"
            ></el-input>
          </el-form-item>

          <div class="bnt">
            <el-button
              class="enter"
              :disabled="whether"
              type="primary"
              @click="Register('ApsPlan')"
              round
              >登录</el-button
            >
          </div>
        </el-form>
      </el-card>
    </div>
    <div class="clearfix company-logo">
      <div class="logo fl">
        <img class="img-scale" src="../../assets/images/logo.png" alt="" />
      </div>
      <div class="company fl">广东海川工业物联网</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Login",
  data() {
    return {
      formData: {
        name: "",
        password: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入用户",
            trigger: "blur",
          },
          // {
          //   pattern: /^[a-zA-Z0-9_-]{4,16}$/,
          //   message: "请输入正确用户格式",
          //   trigger: "blur",
          // },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          // {
          //   pattern: /^(?=.*\d)(?=.*[a-zA-Z]).{6,20}$/,
          //   message: "你输入的密码不正确",
          //   trigger: "blur",
          // },
        ],
      },
      // 判断验证是否成功
      through: false,
      hidden: false,
      max: 0,
      // 标签
      intercept: null,
      move: null,
      plan: null,
      block: null,
      debrisImg: null,
      debris: null,
      when: null,
      // 随机小白块最大最小值
      verifyImg: {
        Xmax: 0,
        Xmin: 0,
        Ymax: 0,
        Ymin: 0,
      },

      blockX: 0,
      blockY: 0,
      schedule: 0,
      whether: false,
      sliding: "滑动验证",
    };
  },
  // 加载后
  mounted() {
    // this.label();
  },
  methods: {
    // 登录跳转
    Register(formName) {
      
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.axios({
            method: "post",
            url: "/checklogin",
            data: this.formData,
          })
            .then((res) => {
              if (res.data.meta.status == 200) {
                this.$message.success("登录成功");
                localStorage.setItem("meisutoken", res.data.data.token);
                localStorage.setItem("meisuUserName", res.data.data.name);
                localStorage.setItem("numTimes", res.data.data.id);
                this.$router.push({ name: "Monitoing" });
              } else {
                this.$message.error("账号或者密码错误");
              }
            })
            .catch((err) => {});
        } else {
          this.$message.error("请重新填写用户和密码");
          return;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
// 引入样式
@import "../../assets/css/login.less";
</style>
